const webcast_pt = require('./webcast.json')
export default webcast_pt